var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCircleClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11019_231358)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0.582031 7.00016C0.582031 3.4561 3.45463 0.583496 6.9987 0.583496C10.5428 0.583496 13.4154 3.4561 13.4154 7.00016C13.4154 10.5436 10.5428 13.4168 6.9987 13.4168C3.4546 13.4168 0.582031 10.5436 0.582031 7.00016Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7835 5.0667C5.58567 4.86887 5.26491 4.86888 5.06709 5.0667C4.86926 5.26453 4.86926 5.58528 5.06709 5.78311L6.28407 7.00009L5.0662 8.21796C4.86838 8.41579 4.86833 8.7365 5.0662 8.93437C5.26403 9.13219 5.58479 9.1322 5.78262 8.93437L7.00048 7.7165L8.2159 8.93192C8.41372 9.12974 8.73448 9.12974 8.93231 8.93192C9.13013 8.73409 9.13013 8.41333 8.93231 8.21551L7.71689 7.00009L8.93465 5.78234C9.13252 5.58447 9.13247 5.26375 8.93465 5.06593C8.73677 4.86805 8.41611 4.86805 8.21824 5.06593L7.00048 6.28368L5.7835 5.0667Z",
    fill: "#494949"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11019_231358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCircleClose);
export default __webpack_public_path__ + "static/media/ic_circle_close.8497d09305f69a69411018814521a3be.svg";
export { ForwardRef as ReactComponent };